import { LineChart } from '@mui/x-charts/LineChart';
import ChartCard from '../../analytics/ChartCard';
import { ErrorRateDataPoint } from '../../../../types/admin';

interface ErrorRateChartProps {
  data: ErrorRateDataPoint[];
  loading?: boolean;
}

export default function ErrorRateChart({ data, loading }: ErrorRateChartProps) {
  const timestamps = data.map((d) => new Date(d.timestamp));
  const errorCounts = data.map((d) => d.error_count);

  return (
    <ChartCard title="Error Rate" subtitle="Errors per hour over last 24 hours" loading={loading} height={400}>
      <LineChart
        xAxis={[
          {
            data: timestamps,
            scaleType: 'time',
            valueFormatter: (date) =>
              new Date(date).toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              }),
          },
        ]}
        yAxis={[
          {
            label: 'Errors/Hour',
          },
        ]}
        series={[
          {
            data: errorCounts,
            label: 'Error Count',
            color: '#d32f2f',
            showMark: false,
            area: true,
          },
        ]}
        grid={{ vertical: false, horizontal: true }}
        sx={{
          '& .MuiLineElement-root': {
            strokeWidth: 2,
          },
        }}
      />
    </ChartCard>
  );
}
